import React from "react";
import styled from "styled-components";
import Sidebar from "./Sidebar";
import SidebarMobile from "./SidebarMobile";
import Footer from "./Footer";
import MobileHeader from "./MobileHeader";

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <AppContainer>
      <Sidebar />
      <MobileHeader />
      <SidebarMobile />
      <MainContent>{children}</MainContent>
      <Footer />
    </AppContainer>
  );
};

const AppContainer = styled.div`
  display: flex;
`;

const MainContent = styled.main`
  flex-grow: 1;
  padding: 20px;
`;

export default MainLayout;
